<template>
    <Headify :data="headMeta" />

    <!-- MAIN CONTAINER - you should never seee the yellow background!!!! -->
    <div class="h-screen min-h-screen w-full bg-yellow-100">
        <!-- TOP NAV SOMETHING -->

        <!-- CONTENT WRAPPER, natural scroll - browser default behavior -->
        <div class="min-h-screen w-full bg-white py-16">
            <!-- CONTENT - whatever you want -->
            <div class="mx-auto w-full max-w-4xl p-4">
                <h1 class="px-2 py-4 text-4xl font-medium text-blue-600">
                    {{ t('UITest') }}
                </h1>
                <div class="text-center">
                    <div class="mx-auto flex max-w-lg justify-center gap-4">
                        <ActionButton
                            value="LEFT"
                            state="primary"
                            :icon="MdiCog"
                            @click="remote.leftOpen = !remote.leftOpen"
                        />
                        <ActionButton
                            value="RIGHT"
                            state="primary"
                            :icon="MdiCog"
                            @click="remote.rightOpen = !remote.rightOpen"
                        />
                    </div>
                    <div class="mx-auto w-full max-w-5xl space-y-6">
                        <div class="text-left">
                            <h2 class="my-6 p-1 text-3xl font-normal text-emerald-400">Buttons</h2>
                        </div>
                        <div
                            class="grid grid-cols-2 text-left sm:grid-cols-3 sm:gap-4 md:grid-cols-3"
                        >
                            <div
                                v-for="state in [
                                    'brand',
                                    'promo',
                                    'primary',
                                    'info',
                                    'success',
                                    'warning',
                                    'danger',
                                    'neutral',
                                    'clean',
                                    'transparent',
                                ]"
                                :key="state"
                            >
                                <div class="p-1 text-center">
                                    <ActionButton
                                        :value="btnConfig.text"
                                        :state="state"
                                        :icon="btnConfig.icon"
                                    />
                                </div>
                            </div>
                            <div class="p-1 text-center">
                                <ActionButton
                                    :value="btnConfig.text"
                                    state="primary"
                                    :is-disabled="true"
                                    :icon="btnConfig.icon"
                                />
                            </div>
                            <div class="p-1 text-center">
                                <SwitchButton
                                    v-model="remote.leftOpen"
                                    state="warning"
                                    label="Sidebar"
                                    label-on="The menu is on"
                                    label-off="The menu is off"
                                />
                            </div>
                        </div>

                        <div class="text-left">
                            <h2 class="my-6 p-1 text-3xl font-normal text-emerald-400">
                                Alert & Buttons
                            </h2>
                        </div>
                        <div class="flex flex-col sm:flex-row">
                            <div class="w-full p-1 text-left">
                                <AlertBox
                                    state="neutral"
                                    :icon="MdiInformation"
                                    title="Material icons"
                                >
                                    <p class="py-1">7296 Material design icons.</p>
                                    <p class="py-1">
                                        Head over to our GitHub repo and suggest it. You can also
                                        contribute your idea if you're feeling creative.
                                    </p>
                                    <div class="mt-4 flex items-center justify-end gap-2">
                                        <ActionButton
                                            value="Cancel"
                                            state="neutral"
                                        />
                                        <ActionButton
                                            value="Send"
                                            state="info"
                                            :icon="btnConfig.icon"
                                        />
                                    </div>
                                </AlertBox>
                            </div>
                            <div class="p-1"></div>
                        </div>
                        <div class="text-left">
                            <h2 class="my-6 p-1 text-3xl font-normal text-emerald-400">Alerts</h2>
                            <div class="my-4 w-full gap-4 p-1 sm:grid sm:grid-cols-2">
                                <div
                                    v-for="state in [
                                        'brand',
                                        'promo',
                                        'primary',
                                        'info',
                                        'success',
                                        'warning',
                                        'danger',
                                        'neutral',
                                    ]"
                                    :key="state"
                                    class="flex-col"
                                >
                                    <AlertBox
                                        :state="state"
                                        :icon="MdiInformation"
                                        :title="`Alert ${state}`"
                                    >
                                        <p class="py-1">7296 Material design icons.</p>
                                        <p class="py-1">
                                            Head over to our GitHub repo and suggest it. You can
                                            also contribute your idea if you're feeling creative.
                                        </p>
                                    </AlertBox>
                                </div>
                            </div>
                        </div>

                        <div class="text-left">
                            <h2 class="my-6 p-1 text-3xl font-normal text-emerald-400">
                                SVG icons
                            </h2>
                            <p class="my-4 text-base">7296 Material design icons.</p>
                            <p class="my-4 text-base">
                                Inline icons example
                                <MdiLock class="-mt-1 inline h-4 w-4 text-indigo-600" />
                                locked account and
                                <MdiCog class="-mt-1 inline h-4 w-4 text-indigo-600" />
                                settings.
                            </p>
                        </div>

                        <div
                            class="grid grid-cols-3 gap-2 text-3xl md:grid-cols-4 md:gap-4 md:text-4xl lg:grid-cols-6"
                        >
                            <MdiAccount
                                class="mx-auto h-10 w-10 rounded-sm border border-blue-400 p-1 text-blue-600"
                            />
                            <MdiLock
                                class="mx-auto h-10 w-10 rounded-sm border border-blue-400 p-1 text-blue-600"
                            />
                            <MdiFilePdfBox
                                class="mx-auto h-10 w-10 rounded-sm border border-blue-400 p-1 text-blue-600"
                            />
                            <MdiClose
                                class="mx-auto h-10 w-10 rounded-sm border border-blue-400 p-1 text-blue-600"
                            />
                            <MdiHome
                                class="mx-auto h-10 w-10 rounded-sm border border-blue-400 p-1 text-blue-600"
                            />
                            <MdiMagnify
                                class="mx-auto h-10 w-10 rounded-sm border border-blue-400 p-1 text-blue-600"
                            />
                            <MdiMenu
                                class="mx-auto h-10 w-10 rounded-sm border border-blue-400 p-1 text-blue-600"
                            />
                            <MdiCog
                                class="mx-auto h-10 w-10 rounded-sm border border-blue-400 p-1 text-blue-600"
                            />
                            <MdiContentSave
                                class="mx-auto h-10 w-10 rounded-sm border border-blue-400 p-1 text-blue-600"
                            />
                            <MdiEmail
                                class="mx-auto h-10 w-10 rounded-sm border border-blue-400 p-1 text-blue-600"
                            />
                            <MdiKeyboard
                                class="mx-auto h-10 w-10 rounded-sm border border-blue-400 p-1 text-blue-600"
                            />
                            <MdiCloudLock
                                class="mx-auto h-10 w-10 rounded-sm border border-blue-400 p-1 text-blue-600"
                            />
                        </div>
                    </div>
                    <div class="mx-auto w-full max-w-5xl space-y-6">
                        <div class="text-left">
                            <h2 class="my-6 p-1 text-3xl font-normal text-emerald-400">
                                SVG spinners
                            </h2>
                        </div>

                        <div
                            class="isolate grid grid-cols-1 gap-2 py-4 text-3xl sm:grid-cols-2 md:grid-cols-3 md:gap-4 md:text-4xl"
                        >
                            <div>
                                <Spinner
                                    type="complex"
                                    :color="`my-4 text-blue-600`"
                                    :color2="`text-emerald-600`"
                                    :text-color="`text-blue-600`"
                                    :overlay="false"
                                    :speed="1000"
                                    :dots="true"
                                    :dot-char="'>'"
                                    :dot-dual="true"
                                    :dot-reverse="true"
                                    :text="
                                        t('loadingExt', {
                                            ext: `${percent}%`,
                                        })
                                    "
                                    :inline="true"
                                    :pulse="false"
                                />
                            </div>
                            <div>
                                <Spinner
                                    type="bars"
                                    :color="`my-4 text-blue-600`"
                                    :color2="`text-emerald-600`"
                                    :text-color="`text-blue-600`"
                                    :overlay="false"
                                    :speed="1000"
                                    :dots="false"
                                    :dot-char="'>'"
                                    :dot-dual="true"
                                    :dot-reverse="true"
                                    :text="
                                        t('sendingExt', {
                                            ext: `${percent}%`,
                                        })
                                    "
                                    :inline="true"
                                    :pulse="false"
                                />
                            </div>
                            <div>
                                <Spinner
                                    type="dots"
                                    :color="`my-4 text-blue-600`"
                                    :color2="`text-emerald-600`"
                                    :text-color="`text-blue-600`"
                                    :overlay="false"
                                    :speed="1000"
                                    :dots="true"
                                    :dot-char="'.'"
                                    :dot-dual="false"
                                    :dot-reverse="false"
                                    :text="t('loading')"
                                    :inline="true"
                                    :pulse="true"
                                />
                            </div>
                            <div>
                                <Spinner
                                    type="clock"
                                    :color="`my-4 text-blue-600`"
                                    :color2="`text-emerald-600`"
                                    :text-color="`text-blue-600`"
                                    :overlay="false"
                                    :speed="2600"
                                    :dots="true"
                                    :dot-char="'/'"
                                    :dot-dual="true"
                                    :dot-reverse="false"
                                    :text="t('loading')"
                                    :inline="true"
                                    :pulse="false"
                                />
                            </div>
                            <div>
                                <Spinner
                                    type="circle"
                                    :color="`my-4 text-blue-600`"
                                    :color2="`text-emerald-600`"
                                    :text-color="`text-blue-600`"
                                    :overlay="false"
                                    :speed="1000"
                                    :dots="true"
                                    :dot-char="'>'"
                                    :dot-dual="true"
                                    :dot-reverse="false"
                                    :text="t('loading')"
                                    :inline="true"
                                    :pulse="true"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- LEFT COLUMN - FILTER -->
    <div
        :class="[
            remote.leftOpen === true ? 'left-0' : '-left-96',
            'fixed top-0 bottom-0 z-[999] h-screen w-96 overflow-y-hidden border-r border-red-400 bg-gray-200 pb-32',
        ]"
    >
        <!-- COLUMN HEADER FIXED TO COLUMN -->
        <div class="bg-slate-700 pt-16">
            <div class="flex w-full">
                <div class="grow p-4 text-left text-white">Filter</div>
                <div class="flex-none p-4">
                    <button
                        type="button"
                        class="rounded-md text-gray-100 hover:text-gray-300 focus:outline-hidden"
                        @click="remote.leftOpen = false"
                    >
                        <span class="sr-only">Close</span>
                        <MdiClose
                            class="h-6 w-6"
                            aria-hidden="true"
                        />
                    </button>
                </div>
            </div>
        </div>
        <!-- COLUMN CONTENT SCROLLABLE -->
        <div class="h-full">
            <div class="block">-CONTENT-</div>
        </div>
    </div>

    <!-- RIGHT COLUMN - PREVIEW -->
    <div
        :class="[
            remote.rightOpen === true ? 'right-0' : '-right-96',
            'fixed top-16 bottom-0 z-[999] h-screen w-96 overflow-y-hidden border-l border-red-400 bg-gray-200 pb-32',
        ]"
    >
        <!-- COLUMN HEADER FIXED TO COLUMN -->
        <div class="bg-slate-700">
            <div class="flex w-full">
                <div class="grow p-4 text-left text-white">Preview</div>
                <div class="flex-none p-4">
                    <button
                        type="button"
                        class="rounded-md text-gray-100 hover:text-gray-300 focus:outline-hidden"
                        @click="remote.rightOpen = false"
                    >
                        <span class="sr-only">Close</span>
                        <MdiClose
                            class="h-6 w-6"
                            aria-hidden="true"
                        />
                    </button>
                </div>
            </div>
        </div>
        <!-- COLUMN CONTENT SCROLLABLE -->
        <div class="h-full overflow-y-auto p-4">
            <div class="block">
                Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Class aptent taciti
                sociosqu ad litora torquent per conubia nostra, per inceptos hymenaeos. Cras pede
                libero, dapibus nec, pretium sit amet, tempor quis. Fusce consectetuer risus a nunc.
                Nunc auctor. Nulla turpis magna, cursus sit amet, suscipit a, interdum id, felis.
                Curabitur ligula sapien, pulvinar a vestibulum quis, facilisis vel sapien. Nulla
                est. Nunc dapibus tortor vel mi dapibus sollicitudin. Class aptent taciti sociosqu
                ad litora torquent per conubia nostra, per inceptos hymenaeos. Duis risus. Itaque
                earum rerum hic tenetur a sapiente delectus, ut aut reiciendis voluptatibus maiores
                alias consequatur aut perferendis doloribus asperiores repellat. Sed convallis magna
                eu sem. Nunc tincidunt ante vitae massa. Duis pulvinar. In dapibus augue non sapien.
                Proin in tellus sit amet nibh dignissim sagittis. Etiam neque. Sed convallis magna
                eu sem. Mauris elementum mauris vitae tortor. Praesent vitae arcu tempor neque
                lacinia pretium. Curabitur ligula sapien, pulvinar a vestibulum quis, facilisis vel
                sapien. Curabitur bibendum justo non orci. Etiam ligula pede, sagittis quis,
                interdum ultricies, scelerisque eu. Et harum quidem rerum facilis est et expedita
                distinctio. Duis viverra diam non justo. Curabitur bibendum justo non orci. Duis
                condimentum augue id magna semper rutrum. Praesent vitae arcu tempor neque lacinia
                pretium. Nulla non arcu lacinia neque faucibus fringilla. In laoreet, magna id
                viverra tincidunt, sem odio bibendum justo, vel imperdiet sapien wisi sed libero.
                Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus
                mus. Praesent dapibus. Maecenas sollicitudin. Sed ut perspiciatis unde omnis iste
                natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam,
                eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta
                sunt explicabo. Morbi leo mi, nonummy eget tristique non, rhoncus non leo. Nullam
                sit amet magna in magna gravida vehicula. Nullam sit amet magna in magna gravida
                vehicula. Donec iaculis gravida nulla. Aliquam erat volutpat. Proin pede metus,
                vulputate nec, fermentum fringilla, vehicula vitae, justo. Integer lacinia. Nulla
                turpis magna, cursus sit amet, suscipit a, interdum id, felis. Excepteur sint
                occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id
                est laborum. Curabitur sagittis hendrerit ante. Nullam faucibus mi quis velit.
                Praesent dapibus. Mauris metus. Mauris tincidunt sem sed arcu. Phasellus enim erat,
                vestibulum vel, aliquam a, posuere eu, velit. Ut enim ad minim veniam, quis nostrud
                exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Mauris
                tincidunt sem sed arcu. Cum sociis natoque penatibus et magnis dis parturient
                montes, nascetur ridiculus mus. Mauris dolor felis, sagittis at, luctus sed, aliquam
                non, tellus. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur
                ridiculus mus. Aliquam erat volutpat. Mauris suscipit, ligula sit amet pharetra
                semper, nibh ante cursus purus, vel sagittis velit mauris vel metus. Praesent in
                mauris eu tortor porttitor accumsan. Sed ac dolor sit amet purus malesuada congue.
                Fusce suscipit libero eget elit. Fusce wisi. Integer vulputate sem a nibh rutrum
                consequat. Duis bibendum, lectus ut viverra rhoncus, dolor nunc faucibus libero,
                eget facilisis enim ipsum id lacus. Aenean placerat. Fusce aliquam vestibulum ipsum.
                Integer pellentesque quam vel velit. Suspendisse sagittis ultrices augue. Integer
                pellentesque quam vel velit. Nullam rhoncus aliquam metus. Curabitur ligula sapien,
                pulvinar a vestibulum quis, facilisis vel sapien.
            </div>
        </div>
    </div>

    <ModalPrompt
        :state="confirmModal.state"
        :buttons="confirmModal.buttons"
        :icon="confirmModal.icon"
    />
</template>

<script setup>
    import { reactive, ref } from 'vue';
    import { useRoute } from 'vue-router';
    import Headify from '../components/Headify.vue';
    import Spinner from '../ui/Spinner.vue';
    import navs from '../composables/navs';
    import { t } from '../composables/i18n';
    import ModalPrompt from '../ui/ModalPrompt.vue';
    import ActionButton from '../ui/ActionButton.vue';
    import AlertBox from '../ui/AlertBox.vue';
    import {
        MdiAccount,
        MdiClose,
        MdiCloudLock,
        MdiCog,
        MdiContentSave,
        MdiEmail,
        MdiFilePdfBox,
        MdiHome,
        MdiKeyboard,
        MdiLock,
        MdiMagnify,
        MdiMenu,
        MdiListStatus,
        MdiInformation,
    } from 'materialdesignicons-vue3/icons/';
    import SwitchButton from '../ui/SwitchButton.vue';

    const percent = ref(0);
    const route = useRoute();

    const headMeta = navs().metaFind(route.name);

    const btnConfig = reactive({
        text: 'Action text',
        icon: MdiContentSave,
        click: () => {
            return true;
        },
    });

    const remote = reactive({
        leftOpen: false,
        rightOpen: false,
    });

    const confirmModal = reactive({
        state: {
            open: false,
            title: t('multipleUploadFilesSentTitle'),
            text: t('multipleUploadFilesSent'),
            data: {},
        },
        icon: MdiListStatus,
        buttons: [
            {
                title: t('buttonOk'),
                action: () => {
                    confirmModal.state.open = false;
                },
                class: ' bg-green-400 hover:bg-green-500 text-white',
            },
        ],
    });
</script>
